"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeEntryFromSimpleTable = exports.hasSimpleTableViewableRecords = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledTable_1 = require("./Tables/StyledTable");
const StyledTableHeader_1 = require("./Tables/StyledTableHeader");
const StyledTableContainer_1 = require("./Tables/StyledTableContainer");
const StyledColumnHeader_1 = require("./Tables/StyledColumnHeader");
const StyledSearchBarContainer_1 = require("./Tables/StyledSearchBarContainer");
const StyledMediumText_1 = require("./StyledMediumText");
const StyledTableCell_1 = require("./Tables/StyledTableCell");
const StyledTableRow_1 = require("./Tables/StyledTableRow");
const react_bootstrap_1 = require("react-bootstrap");
const StyledTBody = styled_components_1.default.tbody `
  border-top: none !important;
`;
const SimpleTable = ({ headers, title, body, margin }) => {
    return (
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    react_1.default.createElement(StyledTableContainer_1.StyledTableContainer, { margin: margin ? margin : '' },
        title && (react_1.default.createElement(StyledSearchBarContainer_1.StyledSearchBarContainer, null,
            react_1.default.createElement("div", { className: 'row align-items-center', style: { height: '100%', paddingLeft: '16px' } },
                react_1.default.createElement(StyledMediumText_1.StyledMediumText, { fontWeight: 'bold' }, title)))),
        react_1.default.createElement(StyledTable_1.StyledTable, { className: 'table table-sm table-nowrap', 
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            margin: { bottom: 24 } },
            react_1.default.createElement(StyledTableHeader_1.StyledTableHeader, null,
                react_1.default.createElement("tr", null, headers.map((headerInfo) => (react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, Object.assign({ key: headerInfo.name }, { width: headerInfo.width }), headerInfo.name))))),
            react_1.default.createElement(StyledTBody, null, body.map((row) => (react_1.default.createElement(react_bootstrap_1.Fade, { in: row.shouldShow !== false, key: row.key, unmountOnExit: true },
                react_1.default.createElement(StyledTableRow_1.StyledTableRow, { key: row.key }, row.entries.map((entry, index) => (react_1.default.createElement(StyledTableCell_1.StyledTableCell, Object.assign({ key: row.key + index }, { width: entry.width }), entry.content)))))))))));
};
SimpleTable.propTypes = {
    body: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        key: prop_types_1.default.string,
        entries: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            content: prop_types_1.default.node,
            width: prop_types_1.default.string
        }))
    })),
    headers: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        // @ts-expect-error ts-migrate(2551) FIXME: Property 'required' does not exist on type 'Requir... Remove this comment to see the full error message
        name: prop_types_1.default.string.required,
        width: prop_types_1.default.string
    })),
    margin: prop_types_1.default.string,
    title: prop_types_1.default.string
};
exports.default = SimpleTable;
const removeEntryFromSimpleTable = (rows, row) => {
    const dupRows = [...rows];
    const rowToRemove = dupRows.find((r) => r.id === row.id);
    const modifiableRow = Object.assign({}, rowToRemove);
    modifiableRow.shouldShow = false;
    dupRows.splice(dupRows.findIndex((r) => r.id === row.id), 1, modifiableRow);
    return dupRows;
};
exports.removeEntryFromSimpleTable = removeEntryFromSimpleTable;
const hasSimpleTableViewableRecords = (rows) => {
    return (rows.length > 0 &&
        rows.filter((key) => key.shouldShow !== false).length > 0);
};
exports.hasSimpleTableViewableRecords = hasSimpleTableViewableRecords;
